module.exports = {
	"articleTitle1": "CSG implements first napping station in UGLi",
	"catImage": "bluestar.png",
	"totalCats": 2,
	"name": "Shapiro Ungraduate Library (UgLi)",
	"articleLink1": "https://www.michigandaily.com/news/csg-implements-first-napping-station-ugli",
	"articleLink2": "https://www.michigandaily.com/section/crime/prayer-rug-shapiro-reflection-room-defiled",
	"articleSnippet1": "Apr 28, 2014 ... ... live too far away to do so, a new napping station implemented last week in the \nShapiro Undergraduate Library could be the best alternative.",
	"articleSnippet2": "Feb 6, 2017 ... ... that someone urinated on one of the large prayer rugs located in the reflection \nroom in the basement of the Shapiro Undergraduate Library.",
	"totalMisc": 1,
	"articleTitle2": "Prayer rug in Shapiro reflection room defiled ",
	"address": "919 S University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161208/elr.FEA_.Dogs_.12.07.16.108.jpg?itok=qwE2n1Sm",
			"author": "Emma Richter",
			"caption": "University students pet a therapy dog provided by Therapaws of Michigan to destress before exams at the UGLi on Wednesday."
		}
	],
	"position": {
		"lat": 42.2755,
		"lng": -83.73717
	},
	"tips": [
		{
			"text": "Bring a power strip if you're going to the Ugli basement. There are always zero outlets available",
			"person": "Erik Forkin"
		},
		{
			"text": "If you're trying to study in the Ugli on a Saturday or Sunday have at least one person get there by 9:30 a.m. to save a table by the window on the 3rd of 4th floor.",
			"peson": "Katie Penrod"
		},
		{
			"text": "Magazines and newspapers in the second floor are pretty dope.",
			"person": "Mark Calcagno"
		},
		{
			"text": "3rd floor bathroom (at least for females, not sure about males bathroom) has a great spot to cry by yourself. This is the bathroom right by the elevator. There is a closed off part of the room (it's reserved for breast feeding I think so be considerate)",
			"person": "Aisvaryah Chandrakanthan"
		}
	],
	"bathroomrating": [
		{
			"rating": 1,
			"bathroom": "1st Floor near cafe"
		},
		{
			"rating": 4,
			"bathroom": "3rd Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"studyspot": 1,
		"location": 1,
		"library": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ugli.json
// module id = 992
// module chunks = 0